<app-impersonation-banner></app-impersonation-banner>
<ion-header>
  <ion-toolbar class="header">
    <div class="header-row">
      <div class="header-left">
        @if (activeWizardBranding().logoSrc) {
        <img
          class="logo-img"
          [src]="activeWizardBranding().logoSrc!"
          [alt]="activeWizardBranding().logoAlt"
        />
        } @else {
        <span class="logo-wordmark">{{ activeWizardBranding().wordmarkText || activeWizardBranding().displayName }}</span>
        }
      </div>

      <div class="header-center">
        <div class="title-header">
          @if (isManager()) {
             {{ 'shared.manager_view' | translate }}
          }
        </div>
        <!-- Keep header single-line to avoid showing application reference in the top bar. -->
      </div>

      <div class="header-right">
        @if (showManagerStatusButton()) {
          <ion-button
            fill="clear"
            (click)="openManagerApplications($event)"
            aria-label="Status"
            nz-tooltip
            [nzTooltipTitle]="'Status'"
            nzTooltipPlacement="bottom"
          >
            <ion-icon name="time-outline"></ion-icon>
          </ion-button>
        }
        @if (showSaveButton()) {
          <ion-button
            class="save-button"
            fill="clear"
            (click)="onSaveApplication()"
            [attr.aria-label]="saveButtonTooltip()"
            nz-tooltip
            [nzTooltipTitle]="saveButtonTooltip()"
            nzTooltipPlacement="bottom"
          >
            <span class="save-icon-wrapper">
              <ion-icon name="save-outline"></ion-icon>
              @if (showUnsavedIndicator()) {
                <span class="save-unsaved-dot"></span>
              }
            </span>
          </ion-button>
        }
        <ion-button
          fill="clear"
          (click)="openDashboardWeb($event)"
          aria-label="Open dashboard"
          nz-tooltip
          [nzTooltipTitle]="'application.wizard.common.open_dashboard' | translate"
          nzTooltipPlacement="bottom"
        >
          <ion-icon name="home-outline"></ion-icon>
        </ion-button>

        <ion-select
          class="language-select"
          [value]="translation.translate.currentLang || translation.translate.getCurrentLang() || 'en'"
          interface="popover"
          [interfaceOptions]="languageSelectPopoverOptions"
          (ionChange)="onLanguageChange($any($event.detail.value))"
        >
          @for (lang of languages; track lang.languageISO2) {
          <ion-select-option [value]="lang.languageISO2" class="language-option-item">
            <span class="language-name">{{ lang.languageFullNative }}</span>
          </ion-select-option>
          }
        </ion-select>

        <ion-button
          fill="clear"
          (click)="logout($event)"
          aria-label="Logout"
          nz-tooltip
          [nzTooltipTitle]="'Logout'"
          nzTooltipPlacement="bottom"
        >
          <ion-icon name="power-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
